import { Table } from 'antd'
import React from 'react'

export default function FacilityPreviewTable({ data, blank }) { 
  return (
      <Table dataSource={data} rowKey={(r) => r.id}>
          <Table.Column title="Name" key="name" dataIndex="name" />
          <Table.Column title="Name 2" key="name_2" dataIndex={!blank ? "name_2" : ""} />
          <Table.Column title="Number" key="number" dataIndex={!blank ? "number" : ""} />
          <Table.Column title="Square Footage" key="square_footage" dataIndex={!blank ? "square_footage" : ""} />
          <Table.Column title="Division" key="division" dataIndex={!blank ? "division" : ""} />
          <Table.Column title="Facility Type" key="facility_type" dataIndex={!blank ? "facility_type" : ""} />
          {/* <Table.Column title="Facility Production Units" key="facility_production_units" dataIndex={!blank ? "facility_production_units" : ''} /> */}
      </Table>
  )
}
